import { getCookie, setCookie } from "../../helper/commonFunction";

export function isErrorMonitorAuthed() {
  return !!getCookie("error_monitor_token");
}

export function logoutErrorMonitor() {
  setCookie("error_monitor_token", "", 0);
}